// extracted by mini-css-extract-plugin
export var active = "ProductPageImages-module--active--352ee";
export var container = "ProductPageImages-module--container--c94da";
export var controls = "ProductPageImages-module--controls--65b58";
export var full = "ProductPageImages-module--full--c5424";
export var thumb = "ProductPageImages-module--thumb--e46ac";
export var thumbs = "ProductPageImages-module--thumbs--1371c";